import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { AdminLanguageService } from '../../services/admin-language-service/admin-language.service';
import * as XLSX from '@e965/xlsx';
import { Department } from 'src/app/models/department.model';
import { DashboardComponent } from '../../dashboard/dashboard.component';
import { DashboardService } from '../../dashboard.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { User } from 'src/app/models/user.model';
import { Position } from 'src/app/models/positon.model';
import { Administrator } from 'src/app/models/administrator.model';
import { AdminAuthService } from '../../services/admin-auth-service/admin-auth.service';
import { Training } from 'src/app/models/training.model';
import {AuthService} from "../../services/auth-service/auth.service";
import {Router} from "@angular/router";
import {UserLanguageService} from "../../services/user-language-service/user-language.service";

@Component({
    selector: 'app-user-expiration',
    templateUrl: './user-expiration.component.html',
    styleUrls: ['./user-expiration.component.scss'],
    standalone: false
})
export class UserExpirationComponent implements OnInit {
  labels;
  labelsSub: Subscription;
  lang
  langSub: Subscription;

  constructor(private authService: AuthService, public snackBar: MatSnackBar, public userLanguageService: UserLanguageService, public dialogRef: MatDialogRef<UserExpirationComponent>, public router: Router) { }

  ngOnInit(): void {
    this.langSub = this.userLanguageService.lang$.subscribe((lang) => {
      this.lang = lang;
    })
    this.labelsSub = this.userLanguageService.labels$.subscribe((labels) => {
      this.labels = labels;
    })
  }

  async onNoClick(): Promise<void> {
    this.dialogRef.close();
    this.authService.logout();
    await this.router.navigateByUrl('/');
  }
}
